import { useState, useEffect } from 'react';

/**
 * Hook customizado para gerenciar a autorização de vocalização de áudio
 * Armazena o estado no localStorage para persistir entre recarregamentos
 * @returns {Object} Estado e funções para gerenciar a autorização
 */
const useAudioAutorizacao = () => {
  // Inicializa o estado com o valor do localStorage, se existir
  const [autorizado, setAutorizadoState] = useState(() => {
    try {
      const savedState = localStorage.getItem('audio_autorizado');
      // Se o valor existir e for 'true', retorna true, caso contrário retorna false
      return savedState === 'true';
    } catch (e) {
      console.error('Erro ao acessar localStorage:', e);
      return false;
    }
  });

  // Função para atualizar o estado e salvar no localStorage
  const setAutorizacao = (novoEstado) => {
    try {
      // Atualiza o estado
      setAutorizadoState(novoEstado);
      // Salva no localStorage
      localStorage.setItem('audio_autorizado', novoEstado.toString());
      console.log(`Estado de autorização de áudio definido como: ${novoEstado}`);
    } catch (e) {
      console.error('Erro ao salvar autorização no localStorage:', e);
      // Atualiza o estado mesmo se falhar ao salvar
      setAutorizadoState(novoEstado);
    }
  };

  // Limpar a autorização (usado em debug ou quando necessário forçar nova autorização)
  const limparAutorizacao = () => {
    try {
      localStorage.removeItem('audio_autorizado');
      setAutorizadoState(false);
      console.log('Autorização de áudio removida');
    } catch (e) {
      console.error('Erro ao limpar autorização:', e);
    }
  };

  return { 
    autorizado, 
    setAutorizacao,
    limparAutorizacao
  };
};

export default useAudioAutorizacao; 